import { useState } from 'react';
import ProveedoresList from './List.jsx';
import ProveedorForm from './Form.jsx';
import ProveedorDetail from './Detail.jsx';

export default function ProveedoresPage() {
  const [view, setView] = useState('list');
  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = () => {
    setView('list');
    setSelectedId(null);
    setSelectedData(null);
    setRefreshKey((key) => key + 1);
  };

  const handleBackToList = () => {
    setView('list');
    setSelectedData(null);
    setSelectedId(null);
    setRefreshKey((key) => key + 1);
  };

  if (view === 'create') {
    return <ProveedorForm onCancel={handleBackToList} onSaved={handleCreated} />;
  }

  if (view === 'edit') {
    return <ProveedorForm initialData={selectedData} onCancel={handleBackToList} onSaved={handleCreated} />;
  }

  if (view === 'detail' && selectedId) {
    return (
      <ProveedorDetail
        proveedorId={selectedId}
        onBack={handleBackToList}
        onEdit={(proveedor) => {
          setSelectedData(proveedor);
          setSelectedId(proveedor?.id ?? selectedId);
          setView('edit');
        }}
      />
    );
  }

  return (
    <ProveedoresList
      refreshKey={refreshKey}
      onCreate={() => {
        setSelectedId(null);
        setSelectedData(null);
        setView('create');
      }}
      onSelect={(id) => {
        setSelectedId(id);
        setSelectedData(null);
        setView('detail');
      }}
    />
  );
}
